import { AlarmUiMutation, AlarmUiState } from './types'
import { MutationTree } from 'vuex'

export const mutations: MutationTree<AlarmUiState> = {
  [AlarmUiMutation.setDrawerVisible](state: AlarmUiState, isVisible: boolean) {
    state.drawerVisible = isVisible
  },
}
